import { AnyAction } from 'redux';

import {
    DEMAND_DETAIL_PARTICIPANTS_RECEIVED,
    DEMAND_DETAIL_PARTICIPANTS_SUBMIT,
} from './demand-detail-participants-actions';
import { DEMAND_DETAIL_RESET } from '../demand-detail-actions';
import { DemandAccountParticipant } from '../../../../models/demand-account-participant';
import { ParticipantsFormValues } from '../../models/participants-form-values';
import { StepData } from '../../../../../../common/components/new-stepper/step-data';

export interface DemandDetailParticipantsReducerState {
    stepData: StepData<ParticipantsFormValues>;
    /**
     * The step as the server last handed it over (#2159). `stepData.values`
     * cannot serve: leaving a wizard step parks its input right there.
     */
    baseline?: ParticipantsFormValues;
}

export const initialDemandDetailParticipantsReducerState: DemandDetailParticipantsReducerState = {
    stepData: {
        errors: {},
        values: { participants: [] },
        isValid: false,
        isDirty: false,
    },
};

export const demandDetailParticipantsReducer = (
    state: DemandDetailParticipantsReducerState = initialDemandDetailParticipantsReducerState,
    action: AnyAction
): DemandDetailParticipantsReducerState => {
    const { type } = action;

    switch (type) {
        case DEMAND_DETAIL_PARTICIPANTS_SUBMIT: {
            const data = action['data'] as StepData<ParticipantsFormValues>;
            return {
                ...state,
                stepData: {
                    ...state.stepData,
                    ...data,
                },
            };
        }

        case DEMAND_DETAIL_PARTICIPANTS_RECEIVED: {
            const participants = action['participants'] as DemandAccountParticipant[];
            const values = { participants };

            return {
                ...state,
                stepData: {
                    ...state.stepData,
                    isValid: true,
                    values,
                },
                // The same values, kept apart from the ones the wizard edits.
                baseline: values,
            };
        }

        case DEMAND_DETAIL_RESET: {
            return initialDemandDetailParticipantsReducerState;
        }

        default: {
            return state;
        }
    }
};
